import React, { ReactNode } from 'react';
import { SocketProvider } from './SocketContext';
import { GuideContextProvider } from './GuidingContext';
import { MenuContextProvider } from './MenuContext';

interface CombinedProvidersProps {
  children: ReactNode;
}

const CombinedProviders: React.FC<CombinedProvidersProps> = ({ children }) => {
  return (
    <SocketProvider>
      <GuideContextProvider>
        <MenuContextProvider>{children}</MenuContextProvider>
      </GuideContextProvider>
    </SocketProvider>
  );
};

export default CombinedProviders;
